import React, { forwardRef } from "react";
import RadioButtonAtm from "../../atoms/RadioButtonAtm";
import { Container } from "./SelectListOptionMol.styles";
var SelectListOptionMol = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var content = _ref.content,
    isChecked = _ref.isChecked,
    onChange = _ref.onChange,
    name = _ref.name,
    tabIndex = _ref.tabIndex;
  return /*#__PURE__*/React.createElement(Container, {
    alignItems: "center",
    justifyContent: "space-between",
    hasFullHeight: true,
    tabIndex: tabIndex,
    ref: ref
  }, /*#__PURE__*/React.createElement(RadioButtonAtm, {
    onChange: onChange,
    isChecked: isChecked,
    hasExpandedClickField: true,
    name: name
  }), content);
});
export default SelectListOptionMol;